import $ from 'jquery';

(function(){
    'use strict';
    
    var $headerSkip = $('.smp-js-header-skip a'),
        $headerTip = $('.smp-js-header-tip span'),
        tipHide = false;

        $headerSkip.focusin(function(){ 
            
            tipHide = false;
            $headerTip.removeClass('active');

        }).focusout(function(){
            
            if(!tipHide){
                $headerTip.addClass('active');
            }

        }).click(function(){

            var $anchorContent = $($(this).attr('href'));
            tipHide = true;
    
            $('html, body').animate({
                scrollTop: $anchorContent.offset().top
            }, 300, function(){
                $anchorContent.attr('tabindex', -1).on('blur focusout', function () {
                    $(this).removeAttr('tabindex');
                }).focus();
            });

            return false;
        });
    
    
}());
